import { Mutation, Action } from 'vuex'
import { StoreModuleType } from '@/utils/store'
import { getPickupOrderPageList, getPickupOrderByPickupCode, addPickupOrder, chagePickupOrder, getWaitShipmentOrder,getBag, cancelPickupOrder } from './service'
import { TableListQueryParams, TableDataType, InfoParamsType, CoollectFormDataType, userParamsType, expectType, getBagType, ResSmallBagType } from './data.d'

export interface StateType {
    errorMsg?: string;
    tableData: TableDataType;
    infoData: CoollectFormDataType;
    expectData: expectType;
    getBagData: getBagType;
    smallList: ResSmallBagType;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getlist: Mutation<StateType>;
        getinfo: Mutation<StateType>;
        getUserInfo: Mutation<StateType>;
        getBag:Mutation<StateType>;
    }
    actions: {
        getPickupOrderPageListFn: Action<StateType,StateType>;
        getPickupOrderByPickupCodeFn: Action<StateType,StateType>;
        addPickupOrderFn: Action<StateType,StateType>;
        chagePickupOrderFn: Action<StateType,StateType>;
        getWaitShipmentOrderFn: Action<StateType,StateType>;
        getBagByPickupFn:Action<StateType,StateType>;
        cancelPickupOrderFn: Action<StateType,StateType>;
    }
}

const initState:StateType = {
    errorMsg: undefined,
    tableData: {
        colist: [],
        pagination: {
            total: 0,
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        }
    },
    infoData: {
        id: null,
        actualNumber: null,
        actualWeight: null,
        city: '',
        createdAt: '',
        createdStatus: null,
        expectNumber: null,
        expectWeight: null,
        generateTime: '',
        generateType: null,
        logisticsProvider: '',
        modified: '',
        modifyPickupDate: '',
        modifyTime: '',
        modifyTimePeriod: '',
        objectiveAddress: '',
        pickupCode: '',
        pickupDate: '',
        pickupDriverName: '',
        pickupDriverPhone: '',
        pickupType: null,
        province: '',
        region: '',
        remarks: '',
        site: '',
        status: null,
        timePeriod: '',
        transportAddress: '',
        transportDetailedAddress: '',
        updatedAt: '',
        userCode: '',
        userName: '',
        addressCode: ''
    },
    expectData: {
        expectNumber: '',
        expectWeight:'',
        createPickup: ''
    },
    getBagData:{
        pickupCode:''
    },
    smallList:{
        list:[]
    }
}

const StoreModel:ModuleType = {
    namespaced: true,
    name: 'collectbill',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getlist(state, payload){
            state.tableData = payload
        },
        getinfo(state, payload){
            state.infoData = payload
        },
        getUserInfo(state, payload){
            state.expectData = payload;
        },
        getBag(state, payload){
            // state.getBagData = payload
            state.smallList.list = payload
        }
    },
    actions: {
        //获取揽收列表信息
        async getPickupOrderPageListFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try {
                const req: any = await getPickupOrderPageList(params)
                const { body } = req
                const data = body?.datas || []
                commit('getlist', {
                    ...initState.tableData,
                    colist: data || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0
                    }
                })
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //查询揽收单信息
        async getPickupOrderByPickupCodeFn({commit}, params:InfoParamsType){
            let msg: string | undefined = undefined
            try {
                const req: any = await getPickupOrderByPickupCode(params)
                const { body } = req
                commit('getinfo', body)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //取消揽收单
        async cancelPickupOrderFn({commit}, params:InfoParamsType){
            let msg: string | undefined = undefined
            try {
                const req: any = await cancelPickupOrder(params)
                const { body } = req
                commit('getinfo', body)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //根据客户编号获奖待交运的物流单
        async getWaitShipmentOrderFn({commit}, params:userParamsType){
            let msg: string | undefined = undefined
            try {
                const req: any = await getWaitShipmentOrder(params)
                const { body } = req
                commit('getUserInfo', body)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //根据订单获取揽收小包关联关系
        async getBagByPickupFn({commit}, params:getBagType){
            let msg: string | undefined = undefined
            try {
                const req: any = await getBag(params)
                const { body } = req
                commit('getBag', body)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //新增揽收单
        async addPickupOrderFn({commit}, params: CoollectFormDataType){
            let msg: string | undefined = undefined
            try {
                await addPickupOrder(params)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //修改/更新揽收单信息
        async chagePickupOrderFn({commit}, params: CoollectFormDataType){
            let msg: string | undefined = undefined
            try {
                await chagePickupOrder(params)
                msg = '';
            } catch (error:any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel